import React from 'react';
import { ICampaignDeliverables } from '../../../../interfaces/campaign.interface';
import ViewSubDeliverable from './ViewSubDeliverable';
import ViewDeliverable from './ViewDeliverable';

interface IProps {
    deliverables: ICampaignDeliverables[];
}

const ViewDeliverableSection = ({ deliverables }: IProps) => {
    return (
        <div className="tw-w-full tw-mt-4 tw-rounded-sm tw-py-3 tw-px-4 tw-border tw-border-blue-50 tw-shadow-sm">
            <div className="tw-w-full tw-flex tw-items-center tw-justify-between">
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    <i className="ph-bold ph-image-square lg"></i>
                    <span className="tw-text-base">Deliverables</span>
                </div>
            </div>
            {deliverables.length > 0 && (
                <div className="tw-w-full tw-flex tw-flex-col tw-gap-y-4 tw-mt-6">
                    <>
                        {deliverables.map((deliverable, index) => (
                            <div className="tw-w-full" key={index}>
                                {deliverable.sub_deliverable ? (
                                    <ViewSubDeliverable index={index} deliverable={deliverable} />
                                ) : (
                                    <ViewDeliverable
                                        index={index}
                                        deliverable={deliverable}
                                        deliverables={deliverables}
                                    />
                                )}
                            </div>
                        ))}
                    </>
                </div>
            )}
        </div>
    );
};

export default ViewDeliverableSection;
